export default __webpack_public_path__ + "static/media/create-course-disabled.b98b8769.svg";